import { createReducer, on } from '@ngrx/store';
import { logoutSuccess } from 'src/app/core/store/user/user.actions';
import { MileageArrayHelper } from './helpers/mileage-array.helper';
import * as MileageActions from './mileage.actions';
import { initialState } from './mileage.state';

export const mileageReducer = createReducer(
  initialState,

  on(logoutSuccess, () => initialState),

  // Load Mileage Data
  on(MileageActions.loadMileageData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(MileageActions.loadMileageDataSuccess, (state, { data }) => ({
    ...state,
    data,
    loading: false,
    error: null,
  })),

  on(MileageActions.loadMileageDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(MileageActions.saveMileageEntries, (state, { entries }) => ({
    ...state,
    data: { entries },
    loading: true,
    error: null,
  })),

  on(MileageActions.saveMileageEntriesSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),

  on(MileageActions.saveMileageEntriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(MileageActions.deleteMileageEntry, (state, { entryId }) => {
    try {
      const updatedData = MileageArrayHelper.deleteEntry(state.data, entryId);

      return {
        ...state,
        data: updatedData,
        loading: true, // Set loading to true as we need to persist to Firebase
        error: null,
      };
    } catch (error) {
      return {
        ...state,
        loading: false,
        error: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  }),

  on(MileageActions.deleteMileageEntrySuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),

  on(MileageActions.deleteMileageEntryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
